module.exports = __webpack_public_path__ + "static/princess-logo-c3ff31f539eed4c6e5287686a430717c.jpg";